import React, { useState, useEffect, useRef } from "react";
import { MdOutlineEnergySavingsLeaf, MdEmojiEvents } from "react-icons/md";
import { FaHandHoldingWater, FaSchool, FaDownload, FaPeopleCarry, FaFilter } from "react-icons/fa";
import { TbVaccineBottleOff } from "react-icons/tb";
import { IoFastFood, IoMan } from "react-icons/io5";
import { FaBoxesPacking, FaBox } from "react-icons/fa6";
import { GiTeacher } from "react-icons/gi";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axiosConn from "config/axiosConn";
import { Card, CardHeader, CardBody, CardFooter, CardTitle, Row, Col } from "reactstrap";
import { Container, Image, Button, Form, Table } from "react-bootstrap";
import subThemes from "helper/SubThemes_List";
import ThemeBaseRouting from "helper/ThemeBaseRouting";
import StateList from "../../../helper/State_List.json";
import DistrictList from "../../../helper/District_List.json";
import Helper from "../../../helper/Common_Helper"
import ApexChartMonthWise from "./ApexChartMonthWise";
import ApexChartQuarterWise from "./ApexChartQuarterWise";
import healthy from "../../../assets/images/yoga.png";
import food from "../../../assets/images/sustainable_food_system.png";
import ewaste from "../../../assets/images/renewable.png";
import waste from "../../../assets/images/reduce_waste.png";
import energy from "../../../assets/images/energy-saving.png";
import water from "../../../assets/images/save-water.png";
import plastic from "../../../assets/images/no-plastic.png";
import { toast } from "react-toastify";
import CircleChart2 from "./pieChartLevel2.jsx";
import { FaAngleDown } from "react-icons/fa6";
import { FcCollaboration } from "react-icons/fc";
import DynamicCount from "../../../helper/AutoMation";
import LineCharts from "./LineChart2.jsx";
import ApexChartHeatmap from './ApexHeatChart3';
import ApexChartHeatmap2 from './ApexHeatChart4';
import BarCharts from "./BarCharts";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { IoMdRefreshCircle } from "react-icons/io";
import * as XLSX from 'xlsx';

function LevelTwoDashboard() {
    const navigate = useNavigate();
    const location = useLocation();
    const dropdownRef = useRef(null);
    const [countData, setCountData] = useState({})
    const [setOnboardedCount, setOnboarded] = useState();
    const [setHostesCount, setHostes] = useState();
    const [districtWiseData, setDistrictWiseData] = useState({})
    const [filterDistrict, setFilterDistrict] = useState([]);
    const [filteredSchool, setFilteredSchool] = useState([]);
    const [stateID, setStateID] = useState('');
    const [selectYear, setYear] = useState('');
    const [themeWiseCount, setThemeWiseCount] = useState([]);
    const [schooCount, setSchooCount] = useState({})
    const [isFilterShow, setIsFilterShow] = useState(false);
    const [quarterWiseData, setQuarterWiseData] = useState([])
    const [monthWiseData, setMonthWiseData] = useState([])
    const [chartStatus, setChartStatus] = useState(1)
    const [timeFilter, setTimeFilter] = useState(false)
    const [quickNum, setQuickNum] = useState("")
    const [matrixCount, setMatrixCount] = useState({});
    const [matchedStateCount, setMatchedStateCount] = useState(null);
    const [collaborationCount, setCollaborationCount] = useState(0)
    const [selectedDuration, setSelectedDuration] = useState("");
    const [themeWiseCountEvent, setThemeWiseCountEvent] = useState({
        lifestylesAdoptedCount: {},
        foodSystemsCount: {},
        eWasteReducedCount: {},
        wasteReducedCount: {},
        energySavedCount: {},
        waterSavedCount: {},
        plasticReducedCount: {},
    });

    const stateNames = location.state?.stateValue;
    console.log('stateNames', stateNames);

    if (stateNames) {
        localStorage.setItem('filterDataState', stateNames);
    }

    const stateName = localStorage.getItem('filterDataState');

    console.log('82222222222', stateName);

    const [filterData, setFilterData] = useState(location?.state?.data || {
        state: stateName || "",
        district: "",
        theme_name: "",
        sub_themes: "",
        school_name: "",
        implemnt_mode: "",
        event_type: "",
        fromDate: "",
        toDate: ""
    })


    // useEffect(() => {
    //     setFilterData({['state']:stateName})
    //     if (filterData.state) {
    //         localStorage.setItem('filterDataState', filterData.state);
    //     }
    // }, [filterData.state]);

    const getMatricData = async () => {
        try {
          // Use stateNames from location.state for state-specific data
          if (stateNames) {
            let postData = { state: stateNames };
            const response = await axiosConn('post', `get-matrix-data`, postData);
            console.log('108888',response)
            if (response.data.status === 'success') {
              setMatrixCount(response.data.data);
            }
          }
        } catch (error) {
          console.log(error);
        }
      };


      
      
    

    useEffect(() => {
        getCount(filterData);
        if (stateNames) {
            getMatricData();
          }
    }, [filterData],[stateNames]);

    useEffect(() => {
        let StateId = StateList.find(obj => obj.state_name == filterData.state)?.state_id;
        let filterdistrictList = DistrictList.filter(obj => obj.state_id == 9);
        setFilterDistrict(filterdistrictList);
    }, [])

    const handleSelectState = (data) => {
        setStateID(data);
        setFilteredSchool([])
        let StateName = StateList.find(obj => obj.state_id == data)?.state_name;
        let filterdistrictList = DistrictList.filter(obj => obj.state_id == data);
        setFilterDistrict(filterdistrictList);
        setFilterData(prevData => ({ ...prevData, state: StateName, district: '', school_name: "" }));
        getSchoolList({ state_id: data })
    }

    const handleSelectDistrict = async (value) => {
        setFilteredSchool([])
        setFilterData(prevData => ({ ...prevData, district: value, school_name: "" }));
        let districtid = DistrictList.find(obj => obj.district_name == value)?.district_id;
        getSchoolList({ state_id: stateID, district_id: districtid })
    }

    const handleSelectTheme = async (value) => {
        setFilterData(prevData => ({ ...prevData, theme_name: value, sub_themes: "" }));
    }

  const handleFilterChange = (field, value) => {
    if (field === "toDate") {
      setSelectedDuration(`${filterData.fromDate} to ${value}`);
      if (
        filterData?.fromDate &&
        new Date(filterData?.fromDate) > new Date(value)
      ) {
        toast.error("Start date cannot be greater than end date");
        return;
      }
    }
    setFilterData((prevData) => ({ ...prevData, [field]: value }));
    if (field === "fromDate" || field === "toDate") {
      setQuickNum("");
    }
  };

    const getSchoolList = async (data) => {
        try {
            let response = await axiosConn('post', 'get-school-filter', data)
            if (response.data.status === 'success') {
                setFilteredSchool(response.data.result)
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getCount = async (data) => {
        try {

            setMatchedStateCount(null);  
    
            const response = await fetch('https://ecoclubs.education.gov.in/api/admin-dashboard-count-district-wise', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
    
            const result = await response.json();
    
            // console.log('12345678900000000', result.data);
    
            if (result.status === 'success') {
                const finalData = result?.data?.dataCount;
    
                // Set school count and other data
                setSchooCount({ totalSchoolCount: result?.data?.schoolCount });
                setCountData(finalData);
                setDistrictWiseData(finalData.districtWiseCount);
                setThemeWiseCount(finalData.themeWiseCount);
                setQuarterWiseData(finalData.quarterWise);
                setMonthWiseData(finalData.monthWise);
    
                const collaborationCounts = result?.data?.CollaborationCount;
                // console.log("collaborationCounts", collaborationCounts);
                const matchedState = collaborationCounts?.stateCount?.find(item => item.state === stateName);
                // console.log("matchedState", matchedState);

                if (matchedState) {
                    setMatchedStateCount(matchedState.collaborationCount);
                } else {
                    console.log(`No match for state: ${stateName}`);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const fetchReport = async () => {
        console.log('230000000000',stateName);
        try {
            const res = await fetch('https://ecoclubs.education.gov.in/api/onboarded-school-count-stateWise', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ state: stateName }) 
            });
    
            const result = await res.json();
            // console.log('2399999999999999999999', result.data.count);

            console.log('24555555555555',result);
    
             setOnboarded(result.data?.count);
             setHostes(result.data?.themeEventCount) // if you're using count from model
    
        } catch (err) {
            console.error('Failed to fetch report data:', err);
        } finally {
            // setLoading(false);
        }
    };
    

    const getCountEvents = async (data) => {
        try {
            // Add Delhi to the request payload
            const dataWithState = {
                ...data,
                state: stateName // Include state information here
            };
    
            // Make the POST request with the modified data
            const response = await axiosConn('post', 'admin-dashboard-count', dataWithState);
    
            console.log('Response Data: ', response.data);
    
            // Check if the response is successful
            if (response.data.status === 'success') {

                const themeWiseCountEvent = {
                    lifestylesAdoptedCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.lifestylesAdoptedCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.lifestylesAdoptedCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.lifestylesAdoptedCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.lifestylesAdoptedCount.initiateEvent || 0,
                    },
                    foodSystemsCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.foodSystemsCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.foodSystemsCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.foodSystemsCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.foodSystemsCount.initiateEvent || 0,
                    },
                    eWasteReducedCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.eWasteReducedCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.eWasteReducedCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.eWasteReducedCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.eWasteReducedCount.initiateEvent || 0,
                    },
                    wasteReducedCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.wasteReducedCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.wasteReducedCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.wasteReducedCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.wasteReducedCount.initiateEvent || 0,
                    },
                    energySavedCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.energySavedCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.energySavedCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.energySavedCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.energySavedCount.initiateEvent || 0,
                    },
                    waterSavedCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.waterSavedCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.waterSavedCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.waterSavedCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.waterSavedCount.initiateEvent || 0,
                    },
                    plasticReducedCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.plasticReducedCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.plasticReducedCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.plasticReducedCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.plasticReducedCount.initiateEvent || 0,
                    }
                };
    
                setThemeWiseCountEvent(themeWiseCountEvent);   
            }
        } catch (error) {
            console.log('Error:', error);
        }
    };
    
    useEffect(() => {
        getCountEvents();
        fetchReport();
    }, []);

    const handleClickFilter = (district, filter) => {
        let data = { ...filterData, district };
        data['district'] = district;

        if (filter) {
            if (filter.implemnt_mode) {
                data['implemnt_mode'] = filter.implemnt_mode;
            }
            if (filter.event_type) {
                data['event_type'] = filter.event_type;
            }
        }
        navigate("/admin/view-state", { state: { state:stateName , data: data } })
    }
    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setTimeFilter(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const applyQuickSelect = (quickSelect) => {
        const today = new Date();
        let startDate = null;
        let endDate = new Date();
    
        const quickSelectRanges = {
            last3Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 3);
            },
            last7Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 7);
            },
            last15Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 15);
            },
            lastMonth: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 1);
            },
            last3Months: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 3);
            },
            last6Months: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 6);
            },
            currentYear: () => {
                startDate = new Date(today.getFullYear(), 0, 1);
            },
            previousYear: () => {
                startDate = new Date(today.getFullYear() - 1, 0, 1);
                endDate = new Date(today.getFullYear() - 1, 11, 31);
            },
        };
    
        if (quickSelectRanges[quickSelect]) {
            quickSelectRanges[quickSelect]();
        } else {
            return;
        }

        setSelectedDuration(
            `${startDate.toISOString().split("T")[0]} to ${
              endDate.toISOString().split("T")[0]
            }`
          );
    
        setFilterData(prevData => ({
            ...prevData,
            fromDate: startDate.toISOString().split('T')[0],
            toDate: endDate.toISOString().split('T')[0]
        }));
        setTimeFilter(false);
    };

const handleQuickSelect = (period) => {
    applyQuickSelect(period);
};
    // Function to calculate start and end dates of the selected year
    const calculateYearRange = (year) => {
        if (!year) return { start: '', end: Helper.currentOrPastDate() };

        const startDate = `${year}-01-01`;
        const endDate = `${year}-12-31`;

        return { start: startDate, end: endDate };
    };
    // Calculate the date range for the selected year
    const { start, end } = calculateYearRange(selectYear);

//     const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };
//   scrollToTop()
  const   exportDashboardToPDF = async () => {
    const pdf = new jsPDF("p", "pt", "a4");
    let yPos = 20;

    // Title
    pdf.setFontSize(20);
    pdf.setTextColor("#4A4A4A");
    pdf.text("Superadmin Dashboard", 20, yPos);
    yPos += 40;

    const setSectionHeader = (text) => {
      pdf.setFontSize(16);
      pdf.setTextColor("#0080FF");
      pdf.text(text, 20, yPos);
      yPos += 30;
    };

    const calculateTotals = (data) => {
      const totalRow = data.reduce((totals, row) => {
        return row.map((value, index) =>
          index === 0 ? "Total" : (totals[index] || 0) + value
        );
      }, []);
      return totalRow;
    };

    // 1. Events Summary (Theme-wise)
    setSectionHeader("Events Summary");
    console.log('4333333333333333333',countData);
    if (countData?.themeWisetotalEventCount) {
      const eventsData = Object.entries(countData.themeWisetotalEventCount).map(
        ([key, val]) => [
          key,
          val.totalEvent,
          val.completedEvent,
          val.ongoingEvent,
          val.initiateEvent,
        ]
      );
      const totals = calculateTotals(eventsData);
      pdf.autoTable({
        startY: yPos,
        head: [["Theme", "Total", "Completed", "Ongoing", "Initiated"]],
        body: [...eventsData, totals],
        theme: "grid",
        styles: { halign: "center" },
      });
      yPos += pdf.lastAutoTable.finalY + 20;
    }

    // 2. Events Summary (States/UTs-wise)
    setSectionHeader("Number of Events (States/UTs/ABs wise)");
    if (countData?.stateWiseCount) {
      const statesData = Object.entries(countData.stateWiseCount).map(
        ([state, counts]) => [
          state,
          counts.totalCount,
          counts.completedEvent,
          counts.ongoingEvent,
          counts.initiateEvent,
          counts.physicalCount,
          counts.digitalCount,
        ]
      );
      const totals = calculateTotals(statesData);
      pdf.autoTable({
        startY: yPos,
        head: [
          [
            "States/UTs/ABs",
            "Completed",
            "Ongoing",
            "Initiated",
          ],
        ],
        body: [...statesData, totals],
        theme: "grid",
        styles: { halign: "center" },
      });
      yPos += pdf.lastAutoTable.finalY + 20;
    }

    function getMonthName(dateString) {
      const date = new Date(dateString);
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      return monthNames[date.getMonth()];
    }
    
    if (countData?.monthWise) {
      const monthWiseData = Object.values(countData.monthWise).map((data) => [
        getMonthName(data.x),
        data.y,
      ]);

      const totals = monthWiseData.reduce((acc, [_, y]) => acc + y, 0);

      pdf.addPage();

      pdf.setFontSize(16);
      const pageWidth = pdf.internal.pageSize.getWidth();
      const text = "Month-wise Count of Events";
      const textWidth = pdf.getTextWidth(text);
      const textOffset = (pageWidth - textWidth) / 2;
      pdf.text(text, textOffset, 20);

      pdf.autoTable({
        startY: 30,
        head: [["Month", "Total Events"]],
        body: [
          ...monthWiseData,
          ["Total", totals],
        ],
        theme: "grid",
        styles: { halign: "center" },
        didDrawPage: (data) => {
          if (data.pageNumber > 1) {
            pdf.autoTable(data.table.head);
          }
        },
      });

      let yPos = pdf.lastAutoTable.finalY + 20;
    }

    pdf.addPage();

    const ageData = [
      ["Age 3-8", countData?.ageWiseParticipants?.age3to8 || 0],
      ["Age 8-11", countData?.ageWiseParticipants?.age8to11 || 0],
      ["Age 11-14", countData?.ageWiseParticipants?.age11to14 || 0],
      ["Age 14-18", countData?.ageWiseParticipants?.age14to18 || 0],
      ["Age 18+", countData?.ageWiseParticipants?.age18plus || 0],
    ];

    const pageWidths = pdf.internal.pageSize.getWidth();
    const texts = "Age-wise Participation Distribution";
    const textWidths = pdf.getTextWidth(texts);
    const textOffsets = (pageWidths - textWidths) / 2;
    pdf.text(texts, textOffsets, 20);

    pdf.autoTable({
      startY: 30,
      head: [["Age Group", "Participants"]],
      body: ageData,
      theme: "grid",
      styles: { halign: "center" },
      didDrawPage: (data) => {
        if (data.pageNumber > 1) {
          pdf.autoTable(data.table.head);
        }
      },
      margin: { bottom: 20 },
    });


    pdf.addPage();

    const eventTypeData = [
      [
        "Action",
        countData?.actionCount || 0,
      ],
      [
        "Awareness",
        countData?.awarenessCount || 0,
      ],
      ["Both", countData?.bothCount || 0],
    ];

    const pageWidth = pdf.internal.pageSize.getWidth();
    const text = "Types of Events";
    const textWidth = pdf.getTextWidth(text);
    const textOffset = (pageWidth - textWidth) / 2;
    pdf.text(text, textOffset, 20);

    pdf.autoTable({
      startY: 30,
      head: [["Event Type", "Count"]],
      body: eventTypeData,
      theme: "grid",
      styles: { halign: "center" },
      didDrawPage: (data) => {
        if (data.pageNumber > 1) {
          pdf.autoTable(data.table.head);
        }
      },
      margin: { bottom: 20 },
    });

    // 6. Digital vs. Physical Events
    pdf.addPage();

    const modeOfEventData = [
      ["Digital Events", countData?.modeOfImplementWisetotalCount?.digitalCount?.totalEvent || 0],
      ["Physical Events", countData?.modeOfImplementWisetotalCount?.physicalCount?.totalEvent || 0],
    ];
    const pageWidthin = pdf.internal.pageSize.getWidth();
    const textin = "Mode of Events: Digital vs. Physical";
    const textWidthin = pdf.getTextWidth(textin);
    const textOffsetin = (pageWidthin - textWidthin) / 2;
    pdf.text(textin, textOffsetin, 20);

    pdf.autoTable({
      startY: 30,
      head: [["Event Type", "Count"]],
      body: modeOfEventData,
      theme: "grid",
      styles: { halign: "center" },
      didDrawPage: (data) => {
        if (data.pageNumber > 1) {
          pdf.autoTable(data.table.head);
        }
      },
      margin: { bottom: 20 },
    });

    // 7. Capturing Charts as Images
    const captureChart = async (classList) => {
      for (const { className, chartName } of classList) {
        const chartElement = document.querySelector(className);
        if (chartElement) {
          const canvas = await html2canvas(chartElement, {
            useCORS: true,
            logging: true,
          });
          const imgData = canvas.toDataURL("image/png");
          const scale = 0.5;
          const imgWidth = canvas.width * scale;
          const imgHeight = canvas.height * scale;
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const margin = 20;
          if (yPos + imgHeight > pageHeight - margin) {
            pdf.addPage();
            yPos = margin;
          }
          const textWidth = pdf.getTextWidth(chartName);
          const textOffset = (pageWidth - textWidth) / 2;
          pdf.text(chartName, textOffset, yPos);
          yPos += 20; // Add space for the chart name
          pdf.addImage(imgData, "PNG", margin, yPos, imgWidth, imgHeight);
          yPos += imgHeight + margin; // Update yPos for the next chart
        }
      }
    };

    const classList = [
      { className: ".barCharts", chartName: "Month-wise Total Events" },
      { className: ".event-count-card", chartName: "Total Events Theme wise" },
      { className: ".ageChart", chartName: "Age-wise Total Events" },
      { className: ".eventTypeChart", chartName: "Event Type-wise Total Events" },
    ];
    
    await captureChart(classList);

    pdf.save("State_admin_Dashboard_Detailed.pdf");
  };

const currentPath = window.location.pathname;

  const exportDashboardToExcel = () => {
    const workbook = XLSX.utils.book_new();

    // Helper function to sanitize sheet names
    const sanitizeSheetName = (name) => name.replace(/[:\\/?*\[\]]/g, "");

    // Helper function to calculate totals
    const calculateTotals = (data) => {
      return data.reduce((totals, row) => {
        return row.map((value, index) =>
          index === 0 ? "Total" : (totals[index] || 0) + value
        );
      }, []);
    };

    // 1. Events Summary (Theme-wise)
    if (countData?.themeWisetotalEventCount) {
      const eventsData = Object.entries(countData.themeWisetotalEventCount).map(
        ([key, val]) => [
          key,
          val.totalEvent,
          val.completedEvent,
          val.ongoingEvent,
          val.initiateEvent,
        ]
      );
      const totals = calculateTotals(eventsData);
      const eventsSheet = XLSX.utils.aoa_to_sheet([
        ["Theme", "Total", "Completed", "Ongoing", "Initiated"],
        ...eventsData,
        totals,
      ]);
      XLSX.utils.book_append_sheet(
        workbook,
        eventsSheet,
        sanitizeSheetName("Events Summary")
      );
    }

    // 2. Events Summary (States/UTs-wise)
    if (countData?.stateWiseCount) {
      const statesData = Object.entries(countData.stateWiseCount).map(
        ([state, counts]) => [
          state,
          counts.totalCount,
          counts.completedEvent,
          counts.ongoingEvent,
          counts.initiateEvent,
          counts.physicalCount,
          counts.digitalCount,
        ]
      );
      const totals = calculateTotals(statesData);
      const statesSheet = XLSX.utils.aoa_to_sheet([
        [
          "States/UTs/ABs",
          "Total",
          "Completed",
          "Ongoing",
          "Initiated",
          "Physical",
          "Digital",
        ],
        ...statesData,
        totals,
      ]);
      XLSX.utils.book_append_sheet(
        workbook,
        statesSheet,
        sanitizeSheetName("States-UTs-ABs Summary")
      );
    }

    function getMonthName(monthIndex) {
      const monthNames = [
        "January", "February", "March", "April", "May", "June", 
        "July", "August", "September", "October", "November", "December"
      ];
      return monthNames[monthIndex];
    }
    
    if (countData?.monthWise) {
      const monthWiseData = countData.monthWise.map((data, index) => {
        const date = new Date(data.x);
        const monthName = getMonthName(date.getMonth());
        return [monthName, data.y];
      });
    
      const totals = calculateTotals(monthWiseData);
    
      const monthSheet = XLSX.utils.aoa_to_sheet([ 
        ["Month", "Total"], 
        ...monthWiseData, 
        totals 
      ], { cellDates: true });
    
      XLSX.utils.book_append_sheet(
        workbook,
        monthSheet,
        sanitizeSheetName("Month-wise Events")
      );
    }

    const ageData = [
      ["Age 3-8", countData?.ageWiseParticipants?.age3to8 || 0],
      ["Age 8-11", countData?.ageWiseParticipants?.age8to11 || 0],
      ["Age 11-14", countData?.ageWiseParticipants?.age11to14 || 0],
      ["Age 14-18", countData?.ageWiseParticipants?.age14to18 || 0],
      ["Age 18+", countData?.ageWiseParticipants?.age18plus || 0],
    ];
    const ageSheet = XLSX.utils.aoa_to_sheet([
      ["Age Group", "Participants"],
      ...ageData,
    ]);
    XLSX.utils.book_append_sheet(
      workbook,
      ageSheet,
      sanitizeSheetName("Age-wise Participation")
    );

    // 5. Types of Events
    const eventTypeData = [
        [
          "Action",
          countData?.actionCount || 0,
        ],
        [
          "Awareness",
          countData?.awarenessCount || 0,
        ],
        ["Both", countData?.bothCount || 0],
      ];

    const eventTypeSheet = XLSX.utils.aoa_to_sheet([
      ["Event Type", "Count"],
      ...eventTypeData,
    ]);
    XLSX.utils.book_append_sheet(
      workbook,
      eventTypeSheet,
      sanitizeSheetName("Types of Events")
    );

    // 6. Digital vs. Physical Events
    const modeOfEventData = [
      ["Digital Events", countData?.modeOfImplementWisetotalCount?.digitalCount?.totalEvent || 0],
      ["Physical Events", countData?.modeOfImplementWisetotalCount?.physicalCount?.totalEvent || 0],
    ];
    const modeSheet = XLSX.utils.aoa_to_sheet([
      ["Event Mode", "Count"],
      ...modeOfEventData,
    ]);
    XLSX.utils.book_append_sheet(
      workbook,
      modeSheet,
      sanitizeSheetName("Mode of Events")
    );

    // Download the Excel file
    XLSX.writeFile(workbook, "State_admin_Dashboard_Report.xlsx");
  };

const resetFilterData = () => {
    setStateID('');
    setFilterDistrict([]);
    setFilteredSchool([]);
    setFilterData({
        state: "",
        district: "",
        school_name: "",
        theme_name: "",
        sub_themes: "",
        implemnt_mode: "",
        event_type: "",
        fromDate: "",
        toDate: ""
    });
    window.location.reload();
};

    return (
        <>
            <section className="scholdashbrdSec superAdminDashboardSec">
                <Container fluid>
                    <div className="dashbrdTopSrchDiv lavel mt-3 mb-1" style={{position:"relative", zIndex:999}}>
                        <h2>State/District <span className="hdngBrkr"> Level </span> SNAPSHOT</h2>
                        <h3 style={{letterSpacing: "0.1em"}}>Welcome State Admin- {filterData.state}</h3>
                        <div className="text-end" style={{ display: "flex", gap: 8, justifyContent: "flex-end", alignItems: "center", flexWrap: "wrap" }}>
                            <Button
                                onClick={() => navigate("/admin/state/themes-analysis")}
                                style={{
                                    background: "linear-gradient(135deg, #0d9488 0%, #2563eb 100%)",
                                    border: "none",
                                    color: "#fff",
                                    fontWeight: 600,
                                    padding: "8px 18px",
                                    borderRadius: 8,
                                    boxShadow: "0 4px 14px rgba(13,148,136,0.35)",
                                    fontSize: 14,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                }}
                            >
                                📊 View Themes Analysis Dashboard
                            </Button>
                            {/* <Button onClick={() => setIsFilterShow(!isFilterShow)}><FaFilter size={20} color="#dddddd" /> Filter</Button> */}
                            <Button onClick={resetFilterData}><IoMdRefreshCircle size={22} color="#dddddd" /> Refresh</Button>
                            <Button onClick={exportDashboardToPDF}>Export Dashboard to PDF</Button>
                            <Button onClick={exportDashboardToExcel}>Export Dashboard to Excel</Button>
                            <Link to="/Ekpedmaakenaam"><Button >EK PED MAA KE NAAM 2.0 DASHBOARD</Button></Link>
                            <Link to="/admin/environment-day-dashboard">
                                <Button style={{background: 'linear-gradient(45deg, #28a745, #218838)', border: 'none', color: 'white', borderRadius: '20px', padding: '8px 18px', marginLeft: '8px', fontWeight: 600, boxShadow: '0 4px 6px rgba(0,0,0,0.1)'}}>
                                    <MdOutlineEnergySavingsLeaf size={18} style={{marginRight: '6px'}}/> Environment Day Dashboard
                                </Button>
                            </Link>
                        </div>
                        {isFilterShow && (
                            <div className="filter my-4">
                                <div className="container-fluid">
                                    <div className="row gy-3">
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="state" disabled={true} className="form-control" value={StateList.find(list => filterData.state?.toLowerCase() === list.state_name?.toLowerCase())?.state_id || ''} onChange={(e) => handleSelectState(e.target.value)}>
                                                    <option value="">All States/UTs/ABs</option>
                                                    {
                                                        console.log(StateList,"state id")
                                                    }
                                                    {StateList.map((list, i) => (
                                                        <option disabled={true} key={i} value={list.state_id}>{list.state_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="district" disabled={true} className="form-control" value={filterData.district} onChange={(e) => { handleSelectDistrict(e.target.value) }}>
                                                    <option value="">All District</option>
                                                    {filterDistrict.map((list, i) => (
                                                        <option key={i} value={list.district_name}>{list.district_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="school_name" disabled={true} className="form-control" value={filterData.school_name} onChange={(e) => handleFilterChange('school_name', e.target.value)}>
                                                    <option value="">All School</option>
                                                    {filteredSchool && filteredSchool.map((school, i) => (
                                                        <option key={i} value={school.school_name}>{school.school_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="theme_name" className="form-control" value={filterData.theme_name} onChange={(e) => { handleSelectTheme(e.target.value) }}>
                                                    <option value="">All Theme</option>
                                                    {ThemeBaseRouting.map((list, i) => (
                                                        <option value={list.value}>{list.lable}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="sub_themes" className="form-control" value={filterData.sub_themes} onChange={(e) => handleFilterChange('sub_themes', e.target.value)}>
                                                    <option value="">All Sub Theme</option>
                                                    {filterData.theme_name && subThemes[filterData.theme_name]?.map((list, i) => (
                                                        <option value={list.value}>{list.label}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="card-stats" ref={dropdownRef}>
                                                {selectedDuration && (
                                                <div
                                                    style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    marginBottom: "5px",
                                                    textAlign: "left",
                                                    }}
                                                >
                                                    <strong>Selected Duration:</strong> {" "}
                                                    {selectedDuration}
                                                </div>
                                                )}
                                                <button
                                                className="buttongreen form-control"
                                                onClick={() => setTimeFilter(!timeFilter)}
                                                >
                                                Select Duration
                                                <FaAngleDown />
                                                </button>
                                                {timeFilter ? (
                                                <div className="contentTime d-flex justify-content-between align-items-start flex-wrap">
                                                    <div className="leftArea">
                                                    <h5 className="text-center">
                                                        Absolute time range
                                                    </h5>
                                                    <hr />
                                                    <div className="card-stats">
                                                    <select
                                                        name="selectYear"
                                                        className="form-control"
                                                        value={selectYear}
                                                        onChange={(e) => {
                                                        setYear(e.target.value);
                                                        setFilterData({
                                                            fromDate: "",
                                                            toDate: "",
                                                            state:filterData.state
                                                        });
                                                        }}
                                                    >
                                                        <option value="">All Years</option>
                                                        <option value="2023">2023</option>
                                                        <option value="2024">2024</option>
                                                        <option value="2025">2025</option>
                                                    </select>
                                                    </div>

                                                    <div className="srchBx _sr1 w-100">
                                                        <label style={{ marginTop: "10px" }} htmlFor="fromDate">
                                                        From Date
                                                        </label>
                                                        <input
                                                        type="date"
                                                        name="fromDate"
                                                        min={start || ""}
                                                        max={end || Helper.currentOrPastDate()}
                                                        className="form-control"
                                                        value={filterData.fromDate}
                                                        onChange={(e) =>
                                                            handleFilterChange("fromDate", e.target.value)
                                                        }
                                                        required={selectYear !== ""} 
                                                        />
                                                    </div>

                                                    <div className="srchBx _sr1 w-100">
                                                        <label style={{ marginTop: "10px" }} htmlFor="toDate">
                                                        To Date
                                                        </label>
                                                        <input
                                                        type="date"
                                                        name="toDate"
                                                        min={filterData.fromDate || ""}
                                                        max={end || Helper.currentOrPastDate()}
                                                        className="form-control"
                                                        value={filterData.toDate}
                                                        onChange={(e) => {
                                                            handleFilterChange("toDate", e.target.value);
                                                            setTimeFilter(false);
                                                        }}
                                                        required={selectYear !== ""} 
                                                        />
                                                    </div>

                                                    </div>
                                                    <div className="RightArea">
                                                    <h5 className="text-center">Quick Ranges</h5>
                                                    <hr />
                                                    <ul>
                                                        <li
                                                        className={quickNum === 1 ? "active" : ""}
                                                        onClick={() => {
                                                            setQuickNum(1);
                                                            handleQuickSelect("last3Days");
                                                        }}
                                                        >
                                                        <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 1}
                                                            readOnly
                                                        />{" "}
                                                        Last 3 Days
                                                        </li>
                                                        <li
                                                        className={quickNum === 2 ? "active" : ""}
                                                        onClick={() => {
                                                            setQuickNum(2);
                                                            handleQuickSelect("last7Days");
                                                        }}
                                                        >
                                                        <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 2}
                                                            readOnly
                                                        />{" "}
                                                        Last 7 Days
                                                        </li>
                                                        <li
                                                        className={quickNum === 3 ? "active" : ""}
                                                        onClick={() => {
                                                            setQuickNum(3);
                                                            handleQuickSelect("last15Days");
                                                        }}
                                                        >
                                                        <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 3}
                                                            readOnly
                                                        />{" "}
                                                        Last 15 Days
                                                        </li>
                                                        <li
                                                        className={quickNum === 4 ? "active" : ""}
                                                        onClick={() => {
                                                            setQuickNum(4);
                                                            handleQuickSelect("lastMonth");
                                                        }}
                                                        >
                                                        <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 4}
                                                            readOnly
                                                        />{" "}
                                                        Last Month
                                                        </li>
                                                        <li
                                                        className={quickNum === 5 ? "active" : ""}
                                                        onClick={() => {
                                                            setQuickNum(5);
                                                            handleQuickSelect("last3Months");
                                                        }}
                                                        >
                                                        <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 5}
                                                            readOnly
                                                        />{" "}
                                                        Last 3 Months
                                                        </li>
                                                        <li
                                                        className={quickNum === 6 ? "active" : ""}
                                                        onClick={() => {
                                                            setQuickNum(6);
                                                            handleQuickSelect("last6Months");
                                                        }}
                                                        >
                                                        <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 6}
                                                            readOnly
                                                        />{" "}
                                                        Last 6 Months
                                                        </li>
                                                        <li
                                                        className={quickNum === 7 ? "active" : ""}
                                                        onClick={() => {
                                                            setQuickNum(7);
                                                            handleQuickSelect("currentYear");
                                                        }}
                                                        >
                                                        <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 7}
                                                            readOnly
                                                        />{" "}
                                                        Current Year
                                                        </li>
                                                        <li
                                                        className={quickNum === 8 ? "active" : ""}
                                                        onClick={() => {
                                                            setQuickNum(8);
                                                            handleQuickSelect("previousYear");
                                                        }}
                                                        >
                                                        <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 8}
                                                            readOnly
                                                        />{" "}
                                                        Previous Year
                                                        </li>
                                                    </ul>
                                                    </div>
                                                </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        
              

                                        {/* <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="event_type" className="form-control" value={filterData.event_type} onChange={(e) => handleFilterChange('event_type', e.target.value)}>
                                                    <option value="">All Type of Event</option>
                                                    <option value="Action">Action</option>
                                                    <option value="Awareness">Awareness</option>
                                                    <option value="Action & Awareness both">Action & Awareness both</option>
                                                </select>
                                            </div>
                                        </div> 
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="implemnt_mode" className="form-control" value={filterData.implemnt_mode} onChange={(e) => handleFilterChange('implemnt_mode', e.target.value)}>
                                                    <option value="">All Mode of Implementation</option>
                                                    <option value="Digital">Digital</option>
                                                    <option value="Physical">Physical</option>
                                                </select>
                                            </div>
                                        </div>*/}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="dashbrdTopSrchDivlavel mt-2 mb-0" style={{position:"relative", zIndex:0}}>
                        <div className="d-flex justify-content-center">
                            <div className="boxdiv boxdivOne">
                            <div className="d-flex justify-content-between p-3">
                <div>
                    <p>Number of <span className="text-success w100">Events</span></p>
                    <h2 onClick={() => navigate(`/admin/view-state?state=${stateName}`, { state: { state:stateName , category: "Events", type: "Total" } })}>
                        {countData.totalCount}
                    </h2>
                </div>
                <MdEmojiEvents size={80} color="#969640" />
            </div>
            <div className="d-flex justify-content-between bg-success bottomBox">
                <div className="bgdanger w-50">
                    <p>Completed</p>
                    <h2 onClick={() => navigate('/admin/view-state', { state: { state:stateName , category: "Events", type: "Completed" } })}>
                        {countData.completedCount}
                    </h2>
                </div>
                <div className="bgdanger w-50">
                    <p>Ongoing</p>
                    <h2 onClick={() => navigate('/admin/view-state', { state: { state:stateName , category: "Events", type: "Ongoing" } })}>
                        {countData.pendingCount}
                    </h2>
                </div>
            </div>
                            </div>
                            <div className="boxdiv boxdivTwo">
                                <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>Number of On-boarded <span className="text-success w100">Schools</span></p>
                                        <h2 onClick={() => navigate('/school-list-state', { state: { state:stateName , category: "Schools", type: "Total" } })}>{setOnboardedCount || 0}</h2>
                                    </div>
                                    <FaSchool size={80} color="#9c6829" />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-50">
                                        <p>Event Hosts</p>
                                        <h2>{setHostesCount || 0}</h2>
                                    </div>
                                    <div className="bgdanger w-50">
                                        <p>Yet to Host</p>
                                        <h2>{Math.max((setOnboardedCount || 0) - (setHostesCount || 0), 0)}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="boxdiv boxdivThree">
                                <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>Number of <span className="text-success w100">Participants</span></p>
                                        <h2 style={{ height: 42 }}></h2>
                                    </div>
                                    <FaPeopleCarry size={80} color="#9f4d9b" />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-100">
                                        <p></p>
                                        <h2>{countData.numberOfParticipants || 0}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="boxdiv boxdivFour">
                <div className="d-flex justify-content-between p-3">
                  <div>
                    <p>
                      Total Number of{" "}
                      <span className="text-success w100">Collaboration</span>
                    </p>
                    <h2 style={{ height: 42 }}></h2>
                  </div>
                  <FcCollaboration size={80} color="#839c30" />
                </div>
                <div className="d-flex justify-content-between bg-success bottomBox">
                  <div
                    className="bgdanger w-100"
                    onClick={() => navigate('/admin/collaboration', { state: { state:stateName , category: "Collaborations", path: currentPath} })}
                  >
                    <p></p>
                    <h2>
                      <Link>
                        <DynamicCount
                          value={matchedStateCount || 0}
                        />
                      </Link>
                    </h2>
                  </div>
                </div>

                {/* <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-100" onClick={() => navigate('/admin/collaboration')}>
                                        <p> </p>
                                        <h2><Link> <DynamicCount value={countData?.CollaborationCount || 0} /></Link></h2>
                                    </div>

                                </div> */}
              </div>
                            {/* <div className="boxdiv boxdivFour">
                            <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>Total Number of{" "}
                                        <span className="text-success w100">Collaboration</span></p>
                                        <h2 style={{ height: 42 }}></h2>
                                    </div>
                                    <FcCollaboration size={80} color="#839c30" />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-100">
                                        <p></p>
                                        <h2 style={{ height: 42 }} onClick={() => navigate('/admin/collaboration', { state: { state:stateName , category: "Collaborations" } })}>
                                        <DynamicCount value={matchedStateCount || 0} />
                    </h2>
                                    </div>

                                </div>
                            </div> */}
                        </div>
                    </div>
                </Container>

                {/* <Container fluid>
                    <div className="dashbrdTopSrchDiv activityListNewDiv mt-4">
                        <h4>Number of Events (Theme wise)</h4>
                        <ul>
                            <li>
                                <a href="#">
                                    <span><Image src={healthy} /></span>
                                    Adopt Healthy Lifestyles
                                    <b className="actNum">{themeWiseCount.lifestylesAdoptedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={food} /></span>
                                    Adopt Sustainable Food Systems
                                    <b className="actNum">{themeWiseCount.foodSystemsCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={ewaste} /></span>
                                    Reduce E-Waste
                                    <b className="actNum">{themeWiseCount.eWasteReducedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={waste} /></span>
                                    Reduce Waste
                                    <b className="actNum">{themeWiseCount.wasteReducedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={energy} /></span>
                                    Save Energy
                                    <b className="actNum">{themeWiseCount.energySavedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={water} /></span>
                                    Save Water
                                    <b className="actNum">{themeWiseCount.waterSavedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={plastic} /></span>
                                    Say No to Single Use Plastic
                                    <b className="actNum">{themeWiseCount.plasticReducedCount || 0}</b>
                                </a>
                            </li>
                        </ul>
                    </div>
                </Container> */}

<Container fluid>
    <div className="container-wrapper mt-4">
        <h4>Number of Events (Theme Wise)</h4>
        <ul className="theme-list">
        <li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#D5F2E3' }}>
            <span className="theme-icon">
                <Image src={healthy} alt="Adopt Healthy Lifestyles" fluid />
            </span>
            <p>Adopt Healthy Lifestyles</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                    <tr>
                        <td 
                            onClick={() => {
                                const state = filterData.state;
                                const themeLabel = 'Adopt Healthy Lifestyles';
                                const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                                window.location.href = url;
                            }}>
                            <b>{themeWiseCountEvent.lifestylesAdoptedCount.totalEvent || 0}</b>
                        </td>
                        <td>
                            <b>{themeWiseCountEvent.lifestylesAdoptedCount.completedEvent || 0}</b>
                        </td>
                        <td>
                            <b>{themeWiseCountEvent.lifestylesAdoptedCount.ongoingEvent || 0}</b>
                        </td>
                        <td>
                            <b>{themeWiseCountEvent.lifestylesAdoptedCount.initiateEvent || 0}</b>
                        </td>
                    </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#FEE2E2' }}>
            <span className="theme-icon">
                <Image src={food} alt="Adopt Sustainable Food Systems" fluid />
            </span>
            <p>Adopt Sustainable Food Systems</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td 
                        onClick={() => {
                            const state = filterData.state;
                            const themeLabel = 'Adopt sustainable food systems';
                            const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                            window.location.href = url;
                        }}>
                        <b>{themeWiseCountEvent.foodSystemsCount.totalEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.foodSystemsCount.completedEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.foodSystemsCount.ongoingEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.foodSystemsCount.initiateEvent || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#FFF3CD' }}>
            <span className="theme-icon">
                <Image src={ewaste} alt="Reduce E-Waste" fluid />
            </span>
            <p>Reduce E-Waste</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td 
                        onClick={() => {
                            const state = filterData.state;
                            const themeLabel = 'Reduce E-Waste';
                            const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                            window.location.href = url;
                        }}>
                        <b>{themeWiseCountEvent.eWasteReducedCount.totalEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.eWasteReducedCount.completedEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.eWasteReducedCount.ongoingEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.eWasteReducedCount.initiateEvent || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#D1E7DD' }}>
            <span className="theme-icon">
                <Image src={waste} alt="Reduce Waste" fluid />
            </span>
            <p>Reduce Waste</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                    <tr>
                        <td 
                            onClick={() => {
                                const state = filterData.state;
                                const themeLabel = 'Reduce Waste';
                                const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                                window.location.href = url;
                            }}>
                            <b>{themeWiseCountEvent.wasteReducedCount.totalEvent || 0}</b>
                        </td>
                        <td>
                            <b>{themeWiseCountEvent.wasteReducedCount.completedEvent || 0}</b>
                        </td>
                        <td>
                            <b>{themeWiseCountEvent.wasteReducedCount.ongoingEvent || 0}</b>
                        </td>
                        <td>
                            <b>{themeWiseCountEvent.wasteReducedCount.initiateEvent || 0}</b>
                        </td>
                    </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#E2E3E5' }}>
            <span className="theme-icon">
                <Image src={energy} alt="Save Energy" fluid />
            </span>
            <p>Save Energy</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td 
                        onClick={() => {
                            const state = filterData.state;
                            const themeLabel = 'Save Energy';
                            const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                            window.location.href = url;
                        }}>
                        <b>{themeWiseCountEvent.energySavedCount.totalEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.energySavedCount.completedEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.energySavedCount.ongoingEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.energySavedCount.initiateEvent || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#D3F9D8' }}>
            <span className="theme-icon">
                <Image src={water} alt="Save Water" fluid />
            </span>
            <p>Save Water</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                 <tr>
                    <td 
                        onClick={() => {
                            const state = filterData.state;
                            const themeLabel = 'Save Water';
                            const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                            window.location.href = url;
                        }}>
                        <b>{themeWiseCountEvent.waterSavedCount.totalEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.waterSavedCount.completedEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.waterSavedCount.ongoingEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.waterSavedCount.initiateEvent || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#FFE6E6' }}>
            <span className="theme-icon">
                <Image src={plastic} alt="Say No to Single Use Plastic" fluid />
            </span>
            <p>Say No to Single Use Plastic</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td 
                        onClick={() => {
                            const state = filterData.state;
                            const themeLabel = 'Say No to Single Use Plastic';
                            const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                            window.location.href = url;
                        }}>
                        <b>{themeWiseCountEvent.plasticReducedCount.totalEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.plasticReducedCount.completedEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.plasticReducedCount.ongoingEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.plasticReducedCount.initiateEvent || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

        </ul>
    </div>
</Container>




                <div className="">
                    <div className="superFullDashboardDiv mt-1">
                        <div className="row">
                            <div className="col-5 col-xs-12 mapindiadiv">
                                <div className="btmTableDivIn">
                                    <div className="tableTopDiv">
                                        <h4 className="bold-text">Number of Events (District wise:  { filterData?.state || ""})</h4>
                                        <div className="Download">
                                            <FaDownload size={20} color="black" onClick={() => Helper.exportTableToCSV('ECO Club District Wise.csv', 'District', districtWiseData)} />
                                        </div>
                                        <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                            <table rules="all" className="table">
                                                <thead className="text-primary">
                                                    <tr className="tblHdngOne">
                                                        <th>&nbsp;</th>
                                                        <th>&nbsp;</th>
                                                        {filterData.implemnt_mode === "Digital" && (
                                                            <th>Mode of Implementation</th>
                                                        )}
                                                        {filterData.implemnt_mode === "Physical" && (
                                                            <th>Mode of Implementation</th>
                                                        )}
                                                        {!filterData.implemnt_mode && (
                                                            <th colSpan={2}>Mode of Implementation</th>
                                                        )}
                                                    </tr>
                                                    <tr>
                                                        <th>Districts</th>
                                                        <th>Total</th>
                                                        {filterData.implemnt_mode === "Digital" && (
                                                            <th>Digital</th>
                                                        )}
                                                        {filterData.implemnt_mode === "Physical" && (
                                                            <th>Physical</th>
                                                        )}
                                                        {!filterData.implemnt_mode && (
                                                            <>
                                                                <th>Digital</th>
                                                                <th>Physical</th>
                                                            </>
                                                        )}
                                                    </tr>
                                                </thead>

        <tbody>
            {districtWiseData && Object.entries(districtWiseData).map(([district, counts]) => (
                <tr key={district}>
                    <td onClick={() => handleClickFilter(district)}><Link>{district}</Link></td>
                    <td onClick={() => counts.totalCount !== 0 ? handleClickFilter(district) : ""}><Link>{counts.totalCount || 0}</Link></td>
                    {filterData.implemnt_mode === "Digital" && (
                        <td onClick={() => counts.digitalCount !== 0 ? handleClickFilter(district, { 'implemnt_mode': 'Digital' }) : ""}><Link>{counts.digitalCount || 0}</Link></td>
                    )}
                    {filterData.implemnt_mode === "Physical" && (
                        <td onClick={() => counts.physicalCount !== 0 ? handleClickFilter(district, { 'implemnt_mode': 'Physical' }) : ""}><Link>{counts.physicalCount || 0}</Link></td>
                    )}
                    {!filterData.implemnt_mode && (
                        <>
                            <td onClick={() => counts.digitalCount !== 0 ? handleClickFilter(district, { 'implemnt_mode': 'Digital' }) : ""}><Link>{counts.digitalCount || 0}</Link></td>
                            <td onClick={() => counts.physicalCount !== 0 ? handleClickFilter(district, { 'implemnt_mode': 'Physical' }) : ""}><Link>{counts.physicalCount || 0}</Link></td>
                        </>
                    )}
                </tr>
            ))}
        </tbody>
    </table>
</div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-7 col-xs-12 fullBoxData">
                                <Row>
                                    <h4 className="mb-2 bold-text">Total Impact  (Theme wise)</h4>
                                    <Col lg="4" md="6" sm="6" className="boxOne _2">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <MdOutlineEnergySavingsLeaf />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">Number of Saplings Planted</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                {matrixCount?.saplings_planted || 0 } 
                                            </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>
                                    <Col lg="4" md="6" sm="6" className="boxOne _3">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <FaHandHoldingWater />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">Amount of Harvest Produced</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    {matrixCount?.Amount_of_organic_produce || 0 }
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>
                                    <Col lg="4" md="6" sm="6" className="boxOne _4">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <TbVaccineBottleOff />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">Amount of waste Collected</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                {matrixCount?.organic_waste_generated || 0 }
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>

                                    <Col lg="4" md="6" sm="6" className="boxOne _5">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <IoFastFood />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">Number of Leaks Detected</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                {matrixCount?.leaks_detected || 0 }
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>

                                    <Col lg="4" md="6" sm="6" className="boxOne _6">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <FaBox />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">Amount of Plastic Waste Collected</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                {matrixCount?.single_use_plastic_bottle_collected || 0 }
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>

                                    <Col lg="4" md="6" sm="6" className="boxOne _7">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <IoMan />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">Energy_Saved_(Total_Energy_Saved_Conserved_(in_Watts))</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                {matrixCount?.electricity_units_consumed || 0 }
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>

                                    <Col lg="4" md="6" sm="6" className="boxOne _8">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <FaBoxesPacking />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">amount of E-Waste collected</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                {matrixCount?.Amount_of_ewaste_collected || 0 }
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>
                                    
                                </Row>
                            </div>
                            <Col sm={12} md={6} lg={6} className="mt-3">
                                        <Card className="card-chart">
                                            <CardHeader>
                                                <Row>
                                                    <Col md="12">
                                                        <div className="d-flex justify-content-center w-100 mt-2" >
                                                            <div className="d-flex justify-content-start mr-5" style={{ marginRight: '15px' }}>
                                                                <Form.Check name="status" value="1" style={{ marginRight: '5px' }} onClick={() => setChartStatus(1)} type="radio" defaultChecked ></Form.Check>
                                                                <Form.Label className="ml-2">Quarter Wise</Form.Label>
                                                            </div>
                                                            <div className="d-flex justify-content-start mr-5" style={{ marginRight: '15px' }}>
                                                                <Form.Check name="status" value="2" style={{ marginRight: '5px' }} onClick={() => setChartStatus(2)} type="radio" ></Form.Check>
                                                                <Form.Label className="ml-2">Month Wise</Form.Label>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardHeader>
                                            <CardBody style={{ marginBlockEnd: '62px' }}>
                                                {chartStatus === 1 ? <ApexChartQuarterWise dynamicData={quarterWiseData} />
                                                    : <ApexChartMonthWise dynamicData={monthWiseData} />}
                                            </CardBody>
                                        </Card>
                                    </Col>

                                    <Col xs={12} sm={12} md={12} lg={6}>
                            <div className="card p-4 ">
                                <h5 className="bold-text pie-padding">Counts of Events (Age wise)</h5>
                                <CircleChart2 state={filterData.state} />
                            </div>
                        </Col>
                        </div>
                    </div>
                </div>
                <div className="mt-2 mb-4 mapindiadiv mt-4">
                    <h4 style={{ fontWeight: 'bold', color: '#000000', fontSize: '24px' }}>
                        Visual Representation
                    </h4>
                </div>

                <Container fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={6}>
                            <div className="card p-4 event-count-card">
                                <h5 className="bold-text">Counts of Events (Theme wise) - Current Academic Year </h5>
                                <LineCharts  state={filterData.state}/>
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={6}>
                            <div className="card p-4 barCharts">
                                <BarCharts state={filterData.state}/>
                            </div>
                        </Col>

                        <Col xs={12} sm={12} md={12} lg={6} >
                            <div className="card p-4 eventTypeChart">
                                <ApexChartHeatmap state={filterData.state}/>
                            </div>
                        </Col>

                        <Col xs={12} sm={12} md={12} lg={6} >
                            <div className="card p-4 ageChart">
                                <ApexChartHeatmap2 state={filterData.state}/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section >
        </>
    );
}

export default LevelTwoDashboard;
